import React, { Suspense } from 'react';

export const IntakeComponent = React.lazy(() => import('./Intake'));

export const Intake = () => (
  <Suspense fallback={null}>
    <IntakeComponent />
  </Suspense>
);
